window.Replication = Backbone.Model.extend({
  defaults: {
    state: {},
    server: {}
  },

  initialize: function () {}

});
